import MwcVueHelperMixin from "mwc-vue-component-helper";

export default MwcVueHelperMixin;
